import { useCallback, useEffect, useRef, useState } from "react";

const memory = new Map();
const memoryOnly = new Set();
const listeners = new Set();
const read = (key) => {
  if (memoryOnly.has(key)) return memory.get(key) ?? true;
  let raw;
  try {
    raw = window.localStorage.getItem(key);
  } catch {
    return memory.has(key) ? memory.get(key) : true;
  }
  let value;
  try { value = JSON.parse(raw); } catch { value = true; }
  const result = typeof value === "boolean" ? value : true;
  memory.set(key, result);
  return result;
};
export default function useIncludeDemo(workspaceId) {
  const key = `op_include_demo_${workspaceId || "personal"}`;
  const current = useRef(key);
  current.current = key;
  const [state, setState] = useState(() => ({ key, value: read(key) }));
  const value = state.key === key ? state.value : read(key);
  useEffect(() => {
    const sync = (changed) => { if (changed === key) setState({ key, value: memory.has(key) ? memory.get(key) : read(key) }); };
    const storage = (event) => { if (event.key === key || event.key === null) { if (event.key === null) { memory.clear(); memoryOnly.clear(); } else { memory.delete(key); memoryOnly.delete(key); } setState({ key, value: read(key) }); } };
    setState({ key, value: read(key) });
    listeners.add(sync);
    window.addEventListener("storage", storage);
    return () => { listeners.delete(sync); window.removeEventListener("storage", storage); };
  }, [key]);
  const setIncludeDemo = useCallback((next) => {
    if (current.current !== key) return;
    const nextValue = typeof next === "function" ? next(memory.has(key) ? memory.get(key) : read(key)) : next;
    memory.set(key, !!nextValue);
    try { window.localStorage.setItem(key, JSON.stringify(!!nextValue)); memoryOnly.delete(key); } catch { memoryOnly.add(key); }
    listeners.forEach((sync) => sync(key));
    setState({ key, value: !!nextValue });
  }, [key]);
  return [value, setIncludeDemo];
}
